import { useEffect, useRef } from 'react';
import { ChatAiAssistState } from '../../hooks/admin/useChatAiAssist';

export function useChatAiAssistPanelScroll(assist: ChatAiAssistState) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const latestEntryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (assist.mode !== 'open' || assist.loading) return;
    const scrollToLatest = () => {
      if (latestEntryRef.current) {
        latestEntryRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        return;
      }
      const container = scrollRef.current;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    };
    requestAnimationFrame(scrollToLatest);
  }, [
    assist.mode,
    assist.loading,
    assist.history,
    assist.expandedTargetId,
    assist.followUpLoadingId,
  ]);

  return { scrollRef, latestEntryRef };
}
